module.exports = __webpack_public_path__ + "img/glassthickness-plus.10e9459a.svg";